/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { Stack } from '@fluentui/react/lib/Stack';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { defineMessages } from 'react-intl';
import { HomePageBenefits } from 'src/appShell/homePage/HomePageBenefits';
import { HomePageDemo } from 'src/appShell/homePage/HomePageDemo';
import { HomePageFooter } from 'src/appShell/homePage/HomePageFooter';
import { HomePageHeader } from 'src/appShell/homePage/HomePageHeader';
import { HomePageScenarios } from 'src/appShell/homePage/HomePageScenarios';
import { HomePageServices } from 'src/appShell/homePage/HomePageServices';
import { Page } from 'src/core/components/Page';
import { useGlobalState } from 'src/core/hooks/useGlobalState';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { getLogger } from 'src/core/services/telemetry/telemetryLogger';

const messages = defineMessages({
    homePageTitle: {
        id: 'portal.homePage.homePageTitle',
        defaultMessage: 'LUIS (Language Understanding) - Cognitive Services - Microsoft'
    }
});

export const HomePage = observer(() => {
    const { localize } = useLocalization();
    const { rootStore, dispatcher } = useGlobalState();

    React.useEffect(() => {
        getLogger('HomePage').logEvent('HomePageURLReferrer', { urlReferrer: document.referrer });
    }, []);

    return (
        <Page pageName="HomePage" title={localize(messages.homePageTitle)}>
            <Stack disableShrink>
                <HomePageHeader isSignedIn={rootStore.authStore.isSignedIn} onSignIn={() => dispatcher.dispatch('login')} />
                <HomePageDemo />
                <HomePageBenefits />
                <HomePageScenarios />
                <HomePageServices />
                <HomePageFooter />
            </Stack>
        </Page>
    );
});
